import { translate } from "@atoms/atom-client/i18n";
import { VariableOptionType } from "../enum/VariableOptionType";

/**
 * Labels for VariableOptionType (variable option / preset category) in the UI
 * language. Single source of truth for UI display (tables, dropdowns, etc.).
 * Entries are read on access: never read one at module load.
 */
export const VARIABLE_OPTION_TYPE_LABELS: Record<VariableOptionType, string> = {
  get [VariableOptionType.HINGE_SET]() {
    return translate(
      "app.manufacturer.variableOptionTypes.hingeSet",
      "Scharnier-Reihe",
    );
  },
  get [VariableOptionType.LOCK_SET]() {
    return translate(
      "app.manufacturer.variableOptionTypes.lockSet",
      "Schloss-Reihe",
    );
  },
  get [VariableOptionType.FEET]() {
    return translate("app.manufacturer.variableOptionTypes.feet", "Fuß");
  },
  get [VariableOptionType.DISHES]() {
    return translate(
      "app.manufacturer.variableOptionTypes.dishes",
      "Einbauschale",
    );
  },
  get [VariableOptionType.HANDLES]() {
    return translate("app.manufacturer.variableOptionTypes.handles", "Griff");
  },
  get [VariableOptionType.TROLLEY_HANDLES]() {
    return translate(
      "app.manufacturer.variableOptionTypes.trolleyHandles",
      "Ausziehgriff",
    );
  },
  get [VariableOptionType.ROLLER_BOARD]() {
    return translate(
      "app.manufacturer.variableOptionTypes.rollerBoard",
      "Rollbrett",
    );
  },
  get [VariableOptionType.RUNNERS]() {
    return translate(
      "app.manufacturer.variableOptionTypes.runners",
      "Rutschleisten",
    );
  },
  get [VariableOptionType.CUTOUTS]() {
    return translate(
      "app.manufacturer.variableOptionTypes.cutouts",
      "Ausschnitt",
    );
  },
};

/** Preset category labels (VariableOptionType + COVER_PADDING). */
export const PRESET_CATEGORY_LABELS: Record<string, string> = {
  // A spread would read the getters once, at import time.
  get [VariableOptionType.HINGE_SET]() {
    return VARIABLE_OPTION_TYPE_LABELS[VariableOptionType.HINGE_SET];
  },
  get [VariableOptionType.LOCK_SET]() {
    return VARIABLE_OPTION_TYPE_LABELS[VariableOptionType.LOCK_SET];
  },
  get [VariableOptionType.FEET]() {
    return VARIABLE_OPTION_TYPE_LABELS[VariableOptionType.FEET];
  },
  get [VariableOptionType.DISHES]() {
    return VARIABLE_OPTION_TYPE_LABELS[VariableOptionType.DISHES];
  },
  get [VariableOptionType.HANDLES]() {
    return VARIABLE_OPTION_TYPE_LABELS[VariableOptionType.HANDLES];
  },
  get [VariableOptionType.TROLLEY_HANDLES]() {
    return VARIABLE_OPTION_TYPE_LABELS[VariableOptionType.TROLLEY_HANDLES];
  },
  get [VariableOptionType.ROLLER_BOARD]() {
    return VARIABLE_OPTION_TYPE_LABELS[VariableOptionType.ROLLER_BOARD];
  },
  get [VariableOptionType.RUNNERS]() {
    return VARIABLE_OPTION_TYPE_LABELS[VariableOptionType.RUNNERS];
  },
  get [VariableOptionType.CUTOUTS]() {
    return VARIABLE_OPTION_TYPE_LABELS[VariableOptionType.CUTOUTS];
  },
  get COVER_PADDING() {
    return translate(
      "app.manufacturer.presetCategories.coverPadding",
      "Deckelpolsterung",
    );
  },
};

/**
 * Returns the label for a preset category (VariableOptionType or "COVER_PADDING")
 * in the UI language. Falls back to the raw value or "—" if unknown.
 */
export function getPresetCategoryLabel(category: string | undefined): string {
  if (category == null || category === "") return "—";
  return PRESET_CATEGORY_LABELS[category] ?? category;
}
